module.exports = __webpack_public_path__ + "media/images/flags/64/Maldives-bf4af59f9dd66f13cd6d9782b5c231fc.png";